import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit, OnDestroy {
  options = {
    direction: 'ltr'
  };
  form: FormGroup;
  loading = false;
  fetching: { [key: string]: any } = {};
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) {
    this.form = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    $.getScript('./assets/js/customizer.js');
  }

  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  async onSubmit() {
    this.loading = true;
    // this.loginForm.reset();
    this.fetching['login'] = this.authService
      .loginUser(this.form.get('email').value, this.form.get('password').value)
      .subscribe(
        res => {
          // console.log('loggg', res);
        },
        err => {
          this.loading = false;
          console.log('err', err);
          swal({
            type: 'error',
            title: err.message
            // showConfirmButton: false,
            // timer: 2000
          });
        }
      );
  }
  // On Forgot password link click
  onForgotPassword() {
    this.router.navigate(['forgotpassword'], { relativeTo: this.route.parent });
  }
  // On registration link click
  onRegister() {
    this.router.navigate(['register'], { relativeTo: this.route.parent });
  }

  signinWithGoogle() {
    this.authService
      .signinWithGoogle()
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
  }

  signinWithFacebook() {
    this.authService
      .signinWithFacebook()
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
  }
}
